// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"MyDevicesPage_skeleton__3X_aU","devicesError":"MyDevicesPage_devicesError__3dOjx"};